import { policy } from 'components/pages/static/content/policy'
import { MetaHead } from 'components/shared/MetaHead'
import { StaticContent } from 'components/shared/StaticContent'
import { Box } from 'components/ui/Box'
import { Breadcrumbs } from 'components/ui/Breadcrumbs'
import { Container } from 'components/ui/Container'
import { Typography } from 'components/ui/Typography'
import useTranslation from 'next-translate/useTranslation'
import { FC } from 'react'
import { useTheme } from 'styled-components'

import { Wrapper } from './styles'

export const PrivacyPolicyPage: FC = () => {
  const theme = useTheme()
  const { t } = useTranslation('staticPages')

  const breadcrumbs = [
    {
      url: '/',
      label: t('breadcrumbs.home'),
    },
    {
      url: '/publichnaya-oferta',
      label: t('breadcrumbs.policy'),
    },
  ]

  return (
    <Wrapper>
      <MetaHead page='privacyPolicy' />
      <Container>
        <Box marginTop={32}>
          <Breadcrumbs links={breadcrumbs} />
        </Box>
        <Box marginTop={24}>
          <Typography as='h1' typography={theme.typography.variants.title.H1}>
            {t('policy.title')}
          </Typography>
        </Box>
        <StaticContent content={policy} />
      </Container>
    </Wrapper>
  )
}
